export function Capitalize(word: string) {
  return (
    word &&
    word.toLowerCase().replace(/\w/, (firstLetter) => firstLetter.toUpperCase())
  );
}
